import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSecureAuth } from '../../contexts/SecureAuthContext';
import { useUser } from '../../contexts/UserContext';
import LoadingSpinner from './LoadingSpinner';

/**
 * Smart redirect component that routes users to the appropriate dashboard
 * based on their role and approval status
 */
const SmartRedirect: React.FC = () => {
  const { user: currentUser, isLoading: authLoading } = useSecureAuth();
  const { userProfile, loading: userLoading, isMasterAccount, isApprovedResearcher } = useUser();


  if (authLoading || userLoading) {
    return <LoadingSpinner />;
  }

  // Not authenticated - go to auth page
  if (!currentUser) {
    return <Navigate to="/researcher/auth" replace />;
  }

  // Master account - go to master dashboard
  if (isMasterAccount) {
    return <Navigate to="/master/dashboard" replace />;
  }

  // Approved researcher - go to researcher dashboard
  if (isApprovedResearcher) {
    return <Navigate to="/researcher/dashboard" replace />;
  }

  // Researcher with profile - route based on status
  if (userProfile && userProfile.role === 'researcher') {
    // Pending or rejected status - go to application status page
    if (userProfile.status === 'pending' || userProfile.status === 'rejected') {
      return <Navigate to="/researcher/application-status" replace />;
    }
    // noprofile status - go to registration to fill out application
    if (userProfile.status === 'noprofile') {
      return <Navigate to="/researcher/register" replace />;
    }
  }

  // New user without profile (still loading or null) - go to registration
  return <Navigate to="/researcher/register" replace />;
};

export default SmartRedirect;
